// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Ingredient-__Ingredient___2duit","container-ingredient-non-active":"app-pages-Ingredient-__Ingredient___3LfJ4"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Ingredient.css
// module id = 2354
// module chunks = 0